import { render, staticRenderFns } from "./SignupStep3.vue?vue&type=template&id=0d5b3560&scoped=true"
import script from "./SignupStep3.vue?vue&type=script&lang=js"
export * from "./SignupStep3.vue?vue&type=script&lang=js"
import style0 from "./SignupStep3.vue?vue&type=style&index=0&id=0d5b3560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b3560",
  null
  
)

export default component.exports